// Generated by pnpm narration:generate from narrationConfig.json.
export { default } from '../../public/narration/production/primitive/en-US-Neural2-J/manifest.json';
